module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "exdl_news"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Times")]), _vm._v(" Online, Monday, 8 September 2014")]), _vm._v(" "), _c('p', {
    staticClass: "exh_news"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTROVERSY IN COURT AS WOLFE TRIAL OPENS")])]), _vm._v(" "), _c('p', {
    staticClass: "ex_news"
  }, [_vm._v("Accused surgeon, Hamish Wolfe, refused to enter a plea on the first day of his trial at the Old Bailey today. In accordance with English law, he will now be tried as if he had pleaded not guilty.")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("Dressed in a dark grey suit, white shirt and blue tie, Wolfe appeared to be paying close attention to proceedings, but when asked to speak, he remained silent, in spite of the judge, Mr Justice Peters, on three occasions, advising him that it was not in his interests to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("Up until the time of his arrest, Wolfe was a leading cancer surgeon, one of the most highly regarded young doctors in the south-west. He was an active sportsman, a rugby and hockey player, experienced and talented at both climbing rock faces and crawling beneath them. He held a pilot’s licence. Generally considered a very handsome man, he seemed blessed with a loving family and a wide circle of friends. He had just announced his engagement to celebrity model Claire Cole. Today, he faces four counts of abduction and murder. If convicted, he is likely to spend the rest of his life in prison.")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("The disappearances of four young women between June 2012 and November 2013 sparked one of the biggest police investigations ever conducted by Avon and Somerset police, but it was a lucky break on the part of Detective Constable Peter Weston that led to Wolfe’s arrest in December 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("Refusal to plead is rare but usually indicates a desire, on the part of the accused, to decline to recognize the authority of the court. Interestingly, three separate psychiatric reports commissioned by the Crown Prosecution Service were submitted incompletely, giving rise to speculation that Wolfe may be unfit to plead and to stand trial. The detective who arrested him, though, emphatically disagreed when the suggestion was put to him.")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("‘Absolute rubbish,’ commented Weston, since promoted to Detective Sergeant. ‘Wolfe understands perfectly well what’s going on and is more than capable of entering a plea. He’s playing games with us. It’s what he does.’")]), _vm._v(" "), _c('p', {
    staticClass: "exi_news"
  }, [_vm._v("The case of the Crown "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("v.")]), _vm._v(" Hamish Wolfe will continue tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "exref_news"
  }, [_vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Maggie Rose: case file 004/TT8914 Hamish Wolfe")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ba8887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0